export default class AulasProxi {
    constructor(axios, url) {
        this.axios = axios;
        this.url = url;
    }
    create(params) {
        return this.axios.post(this.url + '/aulas', params);
    }

    getLista(id) {
        return this.axios.get(this.url + `/aulas/lista?id=${id}`);
    }
    getAll() {
        return this.axios.get(this.url + `/aulas/`);
    }
    get(id) {
        return this.axios.get(this.url + `/aulas/${id}`);
    }
    getConf(id) {
        return this.axios.get(this.url + `/aulas/conf/${id}`);
    }
    getListaEstudiantes(id) {
        return this.axios.get(this.url + `/aulas/listaestudiantes/${id}`);
    }
    getCalendario(id) {
        return this.axios.get(this.url + `/aulas/calendario/${id}`);
    }
    getaulasNotas(id) {
        return this.axios.get(this.url + `/aulas/aulasNotas/${id}`);
    }
    update(id, params) {
        return this.axios.put(this.url + `/aulas/${id}`, params);
    }
    insertEstudiantes(id, params) {
        return this.axios.put(this.url + `/aulas/estudiantes/${id}`, params);
    }
    removeEstudiantes(id, params) {
        return this.axios.put(this.url + `/aulas/removestudiante/${id}`, params);
    }
    remove(id) {
        return this.axios.delete(this.url + `/aulas/${id}`);
    }
    
    //-----------------------------------------PUNTOS DE ATERRISAJE TAREAS-------------------------

    createTarea(id, params) {
        return this.axios.put(this.url + `/tareas/${id}`, params);
    }

    removeTareas(id, params) { 
        return this.axios.put(this.url + `/tareas/remover/${id}`, params);
    }

    removeFile(id, params) { 
        return this.axios.put(this.url + `/tareas/removeFile/${id}`, params);
    }

    editTareas(id, params) {
        return this.axios.put(this.url + `/tareas/editar/${id}`, params);
    }

    entregarTarea(id, params) {
        return this.axios.put(this.url + `/tareas/entregarTarea/${id}`, params);
    }

    entregarEntrega(id, params) {
        return this.axios.put(this.url + `/tareas/editarTareas/${id}`, params);
    }

    getListaHora() {
        return this.axios.get(this.url + `/hora/lista`);
    }

    createHora(params) {
        return this.axios.post(this.url + "/hora", params);
    }

    updateHora(id, params) {
        return this.axios.put(this.url + `/hora/${id}`, params);
    }

    removeHora(id) {
        return this.axios.delete(this.url + `/hora/${id}`);
    }

    async queryHora(querys) {
        return await this.axios.get(this.url + `/hora/query?querys=${querys}`);
    }

    calificarTareas(id, params) {
        return this.axios.put(this.url + `/tareas/calificar/${id}`, params);
    }

    showHidens(id, params) { 
        return this.axios.put(this.url + `/tareas/show/${id}`, params);
    }

    orderActividades(id, params) { 
        return this.axios.put(this.url + `/tareas/orderAct/${id}`, params);
    }

    //-----------------------------------------PUNTOS DE ATERRISAJE LIBROS-------------------------

    createLibros(id, params) {
        return this.axios.put(this.url + `/libros/${id}`, params);
    }

    removeFile(id, params) { 
        return this.axios.put(this.url + `/libros/removeFile/${id}`, params);
    }

    editLibros(id, params) {
        return this.axios.put(this.url + `/libros/editar/${id}`, params);
    }

    //-----------------------------------------PUNTOS DE ATERRISAJE LECTURAS-------------------------youtube

    createLecturas(id, params) {
        return this.axios.put(this.url + `/lecturas/${id}`, params);
    }

    editLecturas(id, params) {
        return this.axios.put(this.url + `/lecturas/editar/${id}`, params);
    }

    //-----------------------------------------PUNTOS DE ATERRISAJE VIDEOS-------------------------

    createVideos(id, params) {
        return this.axios.put(this.url + `/videos/${id}`, params);
    }

    removeFileVideos(id, params) { 
        return this.axios.put(this.url + `/videos/removeFile/${id}`, params);
    }

    editVideos(id, params) {
        return this.axios.put(this.url + `/videos/editar/${id}`, params);
    }

    editVideosForo(id, params) {
        return this.axios.put(this.url + `/videos/foro/${id}`, params);
    }

    editVideosSubForo(id, params) {
        return this.axios.put(this.url + `/videos/subforo/${id}`, params);
    }

    editVideoLike(id, params) {
        return this.axios.put(this.url + `/videos/like/${id}`, params);
    }

    editVideoNoLike(id, params) {
        return this.axios.put(this.url + `/videos/nolike/${id}`, params);
    }

    removeLike(id, params) {
        return this.axios.put(this.url + `/videos/removelike/${id}`, params);
    }

    removeNoLike(id, params) {
        return this.axios.put(this.url + `/videos/removeNolike/${id}`, params);
    }

    removeVideoForo(id, params) {
        return this.axios.put(this.url + `/videos/removeforo/${id}`, params);
    }

    removeVideoSubForo(id, params) {
        return this.axios.put(this.url + `/videos/removesubforo/${id}`, params);
    }

    //-----------------------------------------PUNTOS DE ATERRISAJE YOUTUBE-------------------------

    createYoutube(id, params) {
        return this.axios.put(this.url + `/youtube/${id}`, params);
    }

    editYoutube(id, params) {
        return this.axios.put(this.url + `/youtube/editar/${id}`, params);
    }

     //-----------------------------------------PUNTOS DE ATERRISAJE EVALUACIONES-------------------------

     createEva(id, params) {
        return this.axios.put(this.url + `/eva/${id}`, params);
    }

    editEva(id, params) {
        return this.axios.put(this.url + `/eva/editar/${id}`, params);
    }

    createPreguntas(id, params) {
        return this.axios.put(this.url + `/eva/createPreguntas/${id}`, params);
    }

    updatePreguntas(id, params) {
        return this.axios.put(this.url + `/eva/updatePreguntas/${id}`, params);
    }

    resolver(id, params) {
        return this.axios.put(this.url + `/eva/resolver/${id}`, params);
    }

     //-----------------------------------------PUNTOS DE ATERRISAJE FOROS-------------------------

     createForos(id, params) {
        return this.axios.put(this.url + `/foros/${id}`, params);
    }

    editForos(id, params) {
        return this.axios.put(this.url + `/foros/editar/${id}`, params);
    }

    calificarForos(id, params) {
        return this.axios.put(this.url + `/foros/calificar/${id}`, params);
    }

    //-----------------------------------------PUNTOS DE ATERRISAJE DESCARGAR PDF-------------------------

     desacargaAula( params) {
        return this.axios.post(this.url + `/copyDescar/tareas/`, params);
    }

    copypaste(id, params) {
        return this.axios.put(this.url + `/copyDescar/actividad/${id}`, params);
    }
}